import { Avatar, Button, Divider, Grid, Paper, Popover, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUserSession } from "../slices/userSession/userSessionSlice";
import { MULTI_STATION_ADMIN_ACCESS } from "../util/constants";
import { getWorkgroupGivenJobCode } from "../util/workgroupMapper";
import { useState } from "react";

const StarsAvatar = () => {
  const userSession = useSelector(selectUserSession);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Button onClick={(event) => setAnchorEl(event.currentTarget)}>
        <Avatar sx={{ color: "primary.swaBlue", backgroundColor: "secondary.swaWhite" }}>
          {userSession.firstName.charAt(0) + userSession.lastName.charAt(0)}
        </Avatar>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        data-testid="my-info-popover"
      >
        <Paper variant="outlined" sx={{ maxWidth: "400px", padding: "20px" }}>
          <Typography fontWeight="bold" mb={1}>
            My Info
          </Typography>
          <Grid container>
            <Grid item xs={6} sx={{ textAlign: "left" }}>
              Name
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {userSession.lastName}, {userSession.firstName}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={6} sx={{ textAlign: "left" }}>
              Employee ID
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {userSession.eid}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={6} sx={{ textAlign: "left" }}>
              Home Station
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {userSession.homeStation}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            {userSession.tempStation && (
              <>
                <Grid item xs={6} sx={{ textAlign: "left" }}>
                  Temp Station
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  {userSession.tempStation}
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </>
            )}

            <Grid item xs={6} sx={{ textAlign: "left" }}>
              Workgroup
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {getWorkgroupGivenJobCode(userSession.jobCode)}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={6} sx={{ textAlign: "left" }}>
              Job Code
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {userSession.jobCode}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={6} sx={{ textAlign: "left" }}>
              FT/PT
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {userSession.isFTOrPT}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={6} sx={{ textAlign: "left" }}>
              Access Level
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {userSession.appRole}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {userSession.appRole === MULTI_STATION_ADMIN_ACCESS && (
              <>
                <Grid item xs={6} sx={{ textAlign: "left" }}>
                  Admin Stations
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  {userSession.multiStationAdminStationList.join(", ")}
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </>
            )}
            {userSession.isSuperuser && (
              <>
                <Grid item xs={6} sx={{ textAlign: "left" }}>
                  Superuser
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  Yes
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={6} sx={{ textAlign: "left" }}>
                  Superuser Stations
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                  {userSession.superuserStationList.join(", ")}
                </Grid>
              </>
            )}
          </Grid>
        </Paper>
      </Popover>
    </>
  );
};

export default StarsAvatar;
